import { convertDatesToISO } from '@/config/aux'
import { User } from '../models/user'
import { UserStateType } from './state'
import { httpsCallable } from 'firebase/functions'
// Import Firebase functions
const { getFunctions } = await import('firebase/functions')
const functions = getFunctions()
import axios from 'axios'
import { useUserStore } from '.'
import { getActivePinia } from 'pinia'

export interface UserActionsType {
  getUsers(): Promise<void>
  putUser(user: User): Promise<void>
  deleteUser(id: string): Promise<void>
  getEmployees(): Promise<User[]>
  postUser(data: any): Promise<string>
  putPassword(data: any): Promise<boolean>
  postSendPasswordResetLink(email: string): Promise<boolean>
  postSendNewPassword(email: string, password: string): Promise<boolean>
}

export const UserActions = {
  async getUsers(this: UserStateType) {
    try {
      this.users = []
      const query = `${process.env.VUE_APP_URL_BASE}/users`
      await axios.get(query).then(response => {
        if (response.status === 200) {
          response.data.forEach((user: User) => {
            this.users.push(user)
          })
        }
      })
    } catch (error) {
      console.error('Error getting Users', error)
    }
  },

  async putUser(this: UserStateType, user: User) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/users`
      const data = convertDatesToISO(user.toPlainObject())

      await axios
        .put(query, data, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          if (response.status === 200) {
            //this.users = this.users.map(a => (a.id === user.id ? user : a))
          }
        })
    } catch (error) {
      console.error('Error updating User', error)
    }
  },
  async deleteUser(this: UserStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/users/${id}`
      await axios.delete(query).then(response => {
        if (response.status === 200) {
          //this.users = this.users.filter(a => a.id !== user.id)
        }
      })
    } catch (error) {
      console.error('Error deleting User', error)
    }
  },
  async getEmployees(this: UserStateType): Promise<User[]> {
    try {
      const customers: User[] = []
      const query = `${process.env.VUE_APP_URL_BASE}/users/rol/teams`
      await axios.get(query).then(response => {
        if (response.status === 200) {
          response.data.forEach((customer: User) => {
            customers.push(customer)
          })
        }
      })
      return customers
    } catch (error) {
      console.error('Error getting Customers  ', error)
      return []
    }
  },

  async postUser(this: UserStateType, data: any): Promise<string> {
    try {
      const id = ''
      const newUser = {
        email: data.email,
        password: data.password,
        displayName: data.name,
        newUser: data.user,
      }
      const createUser = httpsCallable(functions, 'createUser')

      await createUser({
        newUser: newUser,
      })
        .then(result => {
          if (result.data) {
            if (data.sendEmailPassword) {
              const userStore = useUserStore(getActivePinia())
              userStore.postSendNewPassword(data.email, data.password)
            }
          }
        })
        .catch(() => {
          throw new Error('Unable to create user')
        })

      return id
    } catch (error) {
      console.error('Error creating user', error)
      throw new Error('Unable to create user')
    }
  },
  async putPassword(this: UserStateType, data: any): Promise<boolean> {
    try {
      let status = false
      const setPassword = {
        uid: data.uid,
        newPassword: data.password,
      }
      const changePassword = httpsCallable(functions, 'changePassword')

      await changePassword({ ...setPassword })
        .then(result => {
          if (result.data) {
            if (result.data) {
              status = true
            }
          }
        })
        .catch(() => {
          throw new Error('Unable to update password')
        })
      return status
    } catch (error) {
      console.error('Error updating passwrod', error)
      throw new Error('Unable updating passwrod')
    }
  },
  async postSendPasswordResetLink(this: UserStateType, email: string): Promise<boolean> {
    try {
      let status = false
      const setPassword = {
        email: email,
      }
      const sendPasswordResetLink = httpsCallable(functions, 'sendPasswordResetLink')

      await sendPasswordResetLink({ ...setPassword })
        .then(result => {
          if (result.data) {
            if (result.data) {
              status = true
            }
          }
        })
        .catch(() => {
          throw new Error('Unable to update password')
        })
      return status
    } catch (error) {
      console.error('Error updating passwrod', error)
      throw new Error('Unable updating passwrod')
    }
  },
  async postSendNewPassword(
    this: UserStateType,
    email: string,
    password: string,
  ): Promise<boolean> {
    try {
      let status = false

      const htmlTemplate = `
      <div style="background-color:#f5f5f5;padding:20px;font-family:Arial,sans-serif;margin:0 auto;text-align:center;">
        <div style="background-color:white;border-radius:8px;padding:30px;max-width:600px;margin:0 auto;box-shadow:0 4px 8px rgba(0,0,0,0.1);">
          <div style="text-align:center;margin-bottom:30px;">
        <h1 style="color:#333;font-size:24px;">Nueva Contraseña</h1>
        <div style="height:3px;background-color:#4a6cf7;width:80px;margin:15px auto;"></div>
          </div>
          <p style="color:#555;font-size:16px;line-height:1.6;">Estimad@ usuario,</p>
          <p style="color:#555;font-size:16px;line-height:1.6;">Su nueva contraseña ha sido generada correctamente. Por favor utilice la siguiente contraseña para acceder:</p>
          <div style="background-color:#f0f4ff;border-radius:5px;padding:15px;margin:20px 0;text-align:center;">
        <p style="font-size:18px;color:#4a6cf7;font-weight:bold;">${password}</p>
          </div>
          <p style="color:#555;font-size:16px;line-height:1.6;">Esta contraseña ha sido generada automáticamente. Por razones de seguridad, le recomendamos cambiar esta contraseña después de iniciar sesión.</p>
          <div style="margin-top:30px;border-top:1px solid #eee;padding-top:20px;text-align:center;">
        <p style="color:#888;font-size:14px;">Para consultas por favor contacte a soporte inmediatamente.</p>
          </div>
        </div>
      </div>
      `
      const data = {
        emails: [email],
        subject: 'Nueva Contraseña para AquaFlow',
        body: htmlTemplate,
      }
      const sendEmailSMTP = httpsCallable(functions, 'sendEmailSMTP')
      await sendEmailSMTP({ ...data })
        .then(result => {
          if (result.data) {
            if (result.data) {
              status = true
            }
          }
        })
        .catch(() => {
          throw new Error('Unable to send password')
        })
      return status
    } catch (error) {
      console.error('Error send passwrod', error)
      throw new Error('Unable send passwrod')
    }
  },
}
